import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { faqData } from '../mockData';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="page-faq">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Sıkça Sorulan Sorular</h1>
          <p className="page-subtitle">
            Hizmetlerimiz hakkında merak ettikleriniz
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section">
        <div className="container-narrow">
          <div className="faq-list">
            {faqData.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${openIndex === index ? 'open' : ''}`}
              >
                <button
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span>{faq.question}</span>
                  <ChevronDown 
                    className={`faq-icon ${openIndex === index ? 'rotate' : ''}`}
                    size={20} 
                  />
                </button>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="section faq-cta">
        <div className="container">
          <div className="faq-cta-content">
            <h2 className="faq-cta-title">Başka Sorunuz mu Var?</h2>
            <p className="faq-cta-subtitle">
              Yanıt bulamadığınız sorular için bizimle iletişime geçebilirsiniz
            </p>
            <a href="/iletisim" className="btn btn-primary">
              İletişime Geç
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
